import PropTypes from 'prop-types';
import React, { Component, useEffect, useMemo, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { toast } from 'react-toastify';
import { Button, Grid } from 'semantic-ui-react';
import { config } from "../../contexts/UrlContext";
import  axios  from 'axios';

const baseStyle = {
	flex: 1,
	display: 'flex',
	height: "250px",
	width: "250px",
	alignItems: 'center',
	padding: '50px',
	borderWidth: 6,
	borderRadius: 2,
	borderColor: '#eeeeee',
	borderStyle: 'dashed',
	backgroundColor: '#fafafa',
	color: '#bdbdbd',
	outline: 'none',
	transition: 'border .24s ease-in-out',
	cursor: "pointer"
};

const activeStyle = {
	borderColor: '#2196f3'
};

const acceptStyle = {
	borderColor: '#00e676',
	color: '#00e676',
};

const rejectStyle = {
	borderColor: '#ff1744',
	color: '#ff1744',
};


const thumbsContainer = {
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',

};

const thumb = {
	display: 'inline-flex',
	marginRight: 8,
	width: '100%',
	height: '100%',
};

const thumbInner = {
	display: 'flex',
	minWidth: 0,
	overflow: 'hidden',
	justifyContent: 'center'
};

const img = {
	display: 'block',
	width: 'auto',
	height: '75%',
	maxHeight: '260px',
	maxWidth: '260px',
	justifyContent: 'center',
	alignItems: 'center',
	backgroundColor: 'rgb(250,250,250)',
	padding: '3px'
};

const imgStyle = {
	height: 'auto',
	width: 'auto',
	display: 'block',
	maxHeight: '260px',
	maxWidth: '260px',
}


function StyledDropzone(props) {
	const [imageFile, setTheme] = useState(props.image);
	const [file, setFile] = useState([1]);
	const [image, setImage] = useState([1]);
	const {
		getRootProps,
		getInputProps,
		isDragActive,
		isDragAccept,
		isDragReject,
	} = useDropzone({
		accept: 'image/*',
		onDrop: acceptedFiles => {
			//Need to set the state of selectedLogo to the acceptedFiles 
			setFile(acceptedFiles);
			setImage(acceptedFiles.map(image => Object.assign(image, {

				preview: URL.createObjectURL(image)
			})));
		},
		minSize: 0,
		maxSize: 5242880,
		multiple: false
	});

	const style = useMemo(() => ({
		...baseStyle,
		...(isDragActive ? activeStyle : {}),
		...(isDragAccept ? acceptStyle : {}),
		...(isDragReject ? rejectStyle : {})
	}), [
		isDragActive,
		isDragReject,
		isDragAccept
	]);

	
	const onClickHandler = async () => {
		try {
			let form = new FormData();

			let element = file[0];
			form.append('File', element);
			form.append('PropertyName', props.name);


			let response;

			if (!props.auth || props.auth === null) {
				response = await axios.post(`${config.baseUrl}/api/Admin/UploadImage`, form, {
					headers: { 
						'Content-Type': 'multipart/form-data'
				}});
			} else {
				let header = {
					'Authorization': `Bearer ${props.auth.user?.access_token}`,
					'Content-Type': 'multipart/form-data'
				}
				response = await axios.post(`${config.baseUrl}/api/Admin/UploadImage`, form, {
					headers: header
				});
			}

			toast.success(response.data);		
		} catch (error) {
			console.log(error);
			toast.error("An error occurred, please check logs")
		}
	}

	const thumbs = image.map(imag => (
		<div style={thumb} key={imag.name}>
			<div style={thumbInner}>
				<img
					src={imag.preview}
					style={imgStyle}
				/>
			</div>
		</div>
	));

	useEffect(() => () => {
		// Make sure to revoke the data uris to avoid memory leaks
		image.forEach(img => URL.revokeObjectURL(img.preview));
	}, [image]);

	return (
		<Grid>
			<Grid.Row>
				<Grid.Column width={8}>
					<div {...getRootProps({ style })} >
						<input {...getInputProps()} />
						{!isDragActive && 'Drag and Drop a new logo'}
						{isDragActive && !isDragReject && "Drop a new logo to get started!"}
						{isDragReject && "File type not accepted. File must be an image and less than 5MB!"}
					</div>
					<br />
					<br />
					<Button className='buttton' style={{ width: "250px", cursor: 'pointer'  }} id="buttton" onClick={onClickHandler}>Upload</Button>
				</Grid.Column>
				<Grid.Column width={8}>
					<div id="admin-sqaure">
						<aside style={thumbsContainer}>
							{thumbs}
						</aside>
					</div>
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export class UploadImage extends Component {

	constructor(props) {
		super(props);

		this.state = {
			image: this.props.image
		}
	}

	render() {

		return (
			<StyledDropzone image={this.props.image} name={this.props.name} auth={this.props.auth} />
		)
	}
}

//Prop Types 
UploadImage.propTypes = {
	image: PropTypes.string.isRequired,
	auth: PropTypes.object.isRequired
}

export default UploadImage